import React from "react";
import closeIcon from "../assets/cross.svg";
import { Colors } from "../utils/colors";
import FileSelection from "./FileSelection";

// export interface File {
// 	original_filename: string;
// 	stored_filename: string;
// 	file_url: string;
// 	content_type: string;
// 	size: number;
// }

interface FileSelectionPopupProps {
	onClose: () => void;
	onFileSelected: (files: File[]) => void;
	isOpen: boolean;
}

const FileSelectionPopup: React.FC<FileSelectionPopupProps> = ({
	onClose,
	onFileSelected,
	isOpen,
}) => {
	if (!isOpen) return null;

	return (
		<div
			className="fixed inset-0 flex items-center justify-center z-50"
			style={{ backgroundColor: Colors.BACKGROUND_OVERLAY }}
		>
			<div
				className="relative rounded-[13px] shadow-[0px_6.29032px_8.3871px_rgba(0,0,0,0.05)]"
				style={{
					backgroundColor: Colors.BACKGROUND_WHITE,
					borderColor: Colors.BORDER_LIGHT,
					border: `1px solid ${Colors.BORDER_LIGHT}`,
				}}
			>
				{/* Close button */}
				<button
					onClick={onClose}
					className="absolute right-5 top-4 w-6 h-6 flex items-center justify-center"
				>
					<img
						src={closeIcon}
						alt="Close"
						style={{ width: "12px", height: "12px" }}
					/>
				</button>
				<FileSelection onFilesSelected={onFileSelected} />
			</div>
		</div>
	);
};

export default FileSelectionPopup;
